export default {
    getPreferences: function (userPrefrences) {
        "use strict";

        let preference = {};
        let preferences = {
            HOS_CYCLE: function(item) {
                preference.cycle = item;
            },
            HOS_CYCLE_USA: function(item) {
                preference.cycleUSA = item;
            },
            HOS_CYCLE_CA: function(item) {
                preference.cycleCA = item;
            },
            HOS_CARGO: function(item) {
                preference.cargo = item;
            },
            HOS_CDL_NUMBER: function(item) {
                preference.cdlNumber = item;
            },
            HOS_CDL_ISSUING_STATE: function(item) {
                preference.cdlIssuingState = item;
            },
            HOS_REGION: function(item) {
                preference.region = item;
            },
            HOS_MAIN_OFFICE_STREET: function(item) {
                preference.mainOfficeStreet = item;
            },
            HOS_MAIN_OFFICE_CITY: function(item) {
                preference.mainOfficeCity = item;
            },
            HOS_MAIN_OFFICE_STATE: function(item) {
                preference.mainOfficeState = item;
            },
            HOS_MAIN_OFFICE_ZIP: function(item) {
                preference.mainOfficeZip = item;
            },
            HOS_HOME_TERMINAL_STREET: function(item) {
                preference.homeTerminalStreet = item;
            },
            HOS_HOME_TERMINAL_CITY: function(item) {
                preference.homeTerminalCity = item;
            },
            HOS_HOME_TERMINAL_STATE: function(item) {
                preference.homeTerminalState = item;
            },
            HOS_HOME_TERMINAL_ZIP: function(item) {
                preference.homeTerminalZip = item;
            },
            HOS_HOME_TERMINAL_COUNTRY: function(item) {
                preference.homeTerminalCountry = item;
            },
            HOS_HOME_TERMINAL_TIMEZONE: function(item) {
                preference.homeTerminalTimezone = item;
            },
            HOS_HOME_TERMINAL_CODE: function(item) {
                preference.homeTerminalCode = item;
            },
            HOS_START_TIME_OF_DAY: function(item) {
                preference.startTimeOfDay = item;
            },
            HOS_VEHICLE_ASSET_ID: function(item) {
                preference.vehicleAssetId = item;
            },
            HOS_TRUCK_ID: function(item) {
                preference.truckId = item;
            },
            HOS_TRAILER_ASSET_ID: function(item) {
                preference.trailerAssetId = item;
            },
            HOS_TRAILER_ASSET_IDS: function(item) {
                preference.trailerAssetIds = item;
            },
            HOS_TRAILER_ID: function(item) {
                preference.trailerId = item;
            },
            HOS_ATTACHED_TRAILERS: function(item) {
                preference.trailerIdMultiple = item;
            },
            HOS_PDF_RECEIVER_EMAIL: function(item) {
                preference.pdfReceiverEmail = item;
            },
            HOS_MANAGE_EQUIPMENT: function(item) {
                preference.manageEquipment = item;
            },
            HOS_SHOW_PERSONAL_CONVEYANCE: function(item) {
                preference.showPersonalConveyance = item;
            },
            HOS_SHOW_YARD_MOVES: function(item) {
                preference.showYardMoves = item;
            },
            HOS_CA_USE_OFF_DUTY_DEFERRAL: function(item) {
                preference.caUseOffDutyDeferral = item;
            },
            HOS_SHIPPING_DOCS_MANIFEST: function(item) {
                preference.shippingDocsManifest = item;
            },
            HOS_CARRIER_DOT_NUMBER: function(item) {
                preference.carrierDOTNumber = item;
            },
            UNIT_OF_DISTANCE: function(item) {
                preference.unitOfDistance = item;
            },
            HOS_CARRIER: function(item) {
                preference.carrierName = item;
            }
        };

        _.forEach(userPrefrences, function (item) {
            if (typeof preferences[item.key] === "function") {
                preferences[item.key](item);
            }
        });

        preference.userId = userPrefrences && userPrefrences.length
            ? userPrefrences[0].userId
            : "";

        preference.homeTerminalAddress = "";
        preference.mainOfficeAddress = "";

        let itHasHomeTerminal = preference.homeTerminalStreet &&
            preference.homeTerminalCity &&
            preference.homeTerminalState &&
            preference.homeTerminalZip;

        let itHasMainOffice = preference.mainOfficeStreet &&
            preference.mainOfficeCity &&
            preference.mainOfficeState &&
            preference.mainOfficeZip;


        if (itHasHomeTerminal) {
            preference.homeTerminalAddress = [
                preference.homeTerminalStreet.stringVal + " ",
                preference.homeTerminalCity.stringVal + " ",
                preference.homeTerminalState.stringVal + " ",
                preference.homeTerminalZip.stringVal
            ].join( "" ).trim();
        }

        if (itHasMainOffice) {
            preference.mainOfficeAddress = [
                preference.mainOfficeStreet.stringVal + " ",
                preference.mainOfficeCity.stringVal + " ",
                preference.mainOfficeState.stringVal + " ",
                preference.mainOfficeZip.stringVal
            ].join( "" ).trim();
        }

        return preference;
    }
};
